import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiKeyType, ApiResponseType, ListResponseType } from '@/types/sharedTypes';

export const getApiKeysApi = async (params?: ApiParams): Promise<ApiResponseType<ListResponseType<ApiKeyType>>> => {
  const uri = '/api-key/';

  return await authApiService.GET(uri, params);
};
